export const ReusableBlockCover = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.0972 8C17.6915 7.99995 16.4788 7.99992 15.4799 8.08152C14.4257 8.16766 13.3771 8.35784 12.3681 8.87195C10.8628 9.63894 9.63894 10.8628 8.87195 12.3681C8.35784 13.3771 8.16766 14.4257 8.08152 15.4799C7.99992 16.4788 7.99995 17.6915 8 19.0972V21.3333C8 22.8061 9.19392 24 10.6667 24H26.6667C28.1395 24 29.3333 22.8061 29.3333 21.3333V10.6667C29.3333 9.19392 28.1395 8 26.6667 8H19.0972Z"
      fill="currentColor"
    />
    <path
      d="M37.3337 40C35.8609 40 34.667 41.1939 34.667 42.6667V53.3333C34.667 54.8061 35.8609 56 37.3337 56H44.903C46.3089 56 47.5217 56 48.5203 55.9184C49.5747 55.8323 50.6233 55.6421 51.6323 55.128C53.1377 54.3611 54.3614 53.1373 55.1283 51.632C55.6425 50.6229 55.8326 49.5744 55.9187 48.52C56.0003 47.5213 56.0003 46.3085 56.0003 44.9027V42.6667C56.0003 41.1939 54.8065 40 53.3337 40H37.3337Z"
      fill="currentColor"
    />
    <path
      d="M10.6667 29.3334C9.19392 29.3334 8 30.5272 8 32V44.9027C7.99995 46.3086 7.99992 47.5214 8.08152 48.52C8.16766 49.5744 8.35784 50.623 8.87195 51.632C9.63894 53.1374 10.8628 54.3611 12.3681 55.128C13.3771 55.6422 14.4257 55.8323 15.4799 55.9184C16.4788 56 17.6915 56 19.0972 56H26.6667C28.1395 56 29.3333 54.8062 29.3333 53.3334V32C29.3333 30.5272 28.1395 29.3334 26.6667 29.3334H10.6667Z"
      fill="currentColor"
    />
    <path
      d="M51.6323 8.87195C50.6233 8.35784 49.5747 8.16766 48.5203 8.08152C47.5217 7.99992 46.3089 7.99995 44.903 8H37.3337C35.8609 8 34.667 9.19392 34.667 10.6667V32C34.667 33.4728 35.8609 34.6667 37.3337 34.6667H53.3337C54.8065 34.6667 56.0003 33.4728 56.0003 32V19.0972C56.0003 17.6915 56.0003 16.4788 55.9187 15.4799C55.8326 14.4257 55.6425 13.3771 55.1283 12.3681C54.3614 10.8628 53.1377 9.63894 51.6323 8.87195Z"
      fill="currentColor"
    />
  </svg>
);
